/* eslint-disable sort-keys-fix/sort-keys-fix, typescript-sort-keys/interface, camelcase */

/*
 * This code is generated by ../../../scripts/generateSchemas.ts.
 * Do not adapt manually. Instead run 'yarn generate'.
 *
 * Source: ../../types/drag-and-drop-exercise/v0.ts
 */
import { createValidator } from '../../helpers/validator';
export var DragAndDropExerciseV0Schema = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  type: 'object',
  properties: {
    title: {
      type: 'string'
    },
    xp: {
      type: 'number'
    },
    course_id: {
      type: 'number'
    },
    chapter_id: {
      type: 'number'
    },
    instructions: {
      type: ['string', 'null'],
      default: null
    },
    assignment: {
      type: 'string'
    },
    hint: {
      type: 'string'
    },
    language: {
      type: 'string',
      enum: ['r', 'python', 'revo', 'sql', 'shell', 'scala', 'julia', 'containers']
    },
    runtime_config: {
      type: 'string'
    },
    solution: {
      type: 'string',
      default: ''
    },
    pre_exercise_code: {
      type: 'string',
      default: ''
    },
    sample_code: {
      type: 'string',
      default: ''
    },
    sct: {
      type: 'string',
      default: ''
    }
  },
  required: ['title', 'xp', 'course_id', 'chapter_id', 'instructions', 'assignment', 'hint', 'language', 'solution', 'pre_exercise_code', 'sample_code', 'sct'],
  definitions: {}
};
export var isValidDragAndDropExerciseV0 = createValidator(DragAndDropExerciseV0Schema);
export var DragAndDropExerciseV0Definition = {
  schema: DragAndDropExerciseV0Schema,
  validate: isValidDragAndDropExerciseV0
};